import React from 'react';
import "./About.css";
import useIntersectionObserver from "../customHooks/useIntersectionObserver.js";
const About = () => {
    const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });
    return (
        <section className={`product-main-section ${isVisible ? "section-animation" : ""}`}
            ref={ref}
            id="one">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 product-main-content-col">
                        <div className="content-tag">
                            <h2 className='colored-text'>About</h2>
                        </div>
                        <div className="content-heading-wrapper">
                            <h2>Build and Manage Intelligent Scrum Teams with Agent Scrum</h2>
                            <p>Unlock the power of AI-driven Agile management with ElixirClaw. Drive efficiency and streamline your operations seamlessly with AI-powered Scrum teammates.</p>
                        </div>

                        <div className="product-pointers-outer-wrapper">
                            <div className="product-pointer-heading">
                                <img
                                    src="https://www.xenonstack.com/hubfs/product-icon-one.svg"
                                    alt="product-icon-one"
                                    loading="lazy"
                                    width="24"
                                    height="24"
                                    style={{ maxWidth: "100%", height: "auto" }}
                                />
                                <h3>Automated Sprint Planning </h3>
                            </div>
                            <p>Utilize AI to automate and optimize sprint planning and operations, improving efficiency and team performance.</p>
                        </div>

                        <div className="product-pointers-outer-wrapper">
                            <div className="product-pointer-heading">
                                <img
                                    src="https://www.xenonstack.com/hubfs/product-icon-two.svg"
                                    alt="product-icon-two"
                                    loading="lazy"
                                    width="24"
                                    height="24"
                                    style={{ maxWidth: "100%", height: "auto" }}
                                />
                                <h3>Smart Story Estimation & Prioritization </h3>
                            </div>
                            <p>Leverage AI to automate and optimize backlog management, improving efficiency and sprint outcomes.</p>
                        </div>

                        <div className="product-pointers-outer-wrapper">
                            <div className="product-pointer-heading">
                                <img
                                    src="https://www.xenonstack.com/hubfs/product-icon-three.svg"
                                    alt="product-icon-three"
                                    loading="lazy"
                                    width="24"
                                    height="24"
                                    style={{ maxWidth: "100%", height: "auto" }}
                                />
                                <h3>Real-Time Progress Tracking </h3>
                            </div>
                            <p>Utilize AI to automate and optimize sprint monitoring and operations, improving efficiency and team responsiveness</p>
                        </div>
                    </div>

                    <div className="col-12 col-sm-8 col-md-6 col-lg-6 product-main-content-image">
                        <img
                            src="https://www.elixirclaw.ai/hubfs/Group.svg"
                            alt="neural-ai-os-framework-for-development"
                            loading="lazy"
                            width="701"
                            height="950"
                            style={{ maxWidth: "100%", height: "auto" }}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
